import { render, staticRenderFns } from "./AbTestConfig.vue?vue&type=template&id=2a05d792&scoped=true"
import script from "./AbTestConfig.vue?vue&type=script&lang=js"
export * from "./AbTestConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a05d792",
  null
  
)

export default component.exports